import { PermissionsType } from 'common/permissions/Permissions';
import { Role } from 'common/permissions/Role';
import { RoleName } from 'common/permissions/Roles';
import { ICommissionRank } from 'server/schema/procedure/request-ranking/CommissionRank';
import { ISiapUserInfo } from 'server/schema/user/siap/services/SiapGetUserInfo';
import { IAuthSamlTransaction } from './AuthSamlTransaction';
import { ICitizen } from './Citizen';
import { IProcedure } from './Procedure';
import { IReadingRequestDocument } from './ReadingRequestDocument';
import { IUserGrant } from './user-grant/UserGrant';

/**
 * Rappresenta un utente di sistema (organigramma)
 */
export interface IUser {
  id: number;
  state: UserState;
  source: UserSource;
  login: string;
  serial: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  enablePassword: boolean;
  email?: string | null;
  password?: string;
  serviceToken?: string;
  role: RoleName;
  areaCode?: string | null;
  grants?: IUserGrant[];
  isTester: boolean;
  isEmployee: boolean;
  /** Strategia di autenticazione */
  strategy?: string;
  originalStrategy?: string;
  /** Cittadino */
  citizenId?: number | null;
  citizen?: ICitizen | null;
  authSamlTransactions?: IAuthSamlTransaction[];
  /** Relazione autore-request-documento per flag visualizzazione */
  readingRequestDocumentsId?: number | null;
  readingRequestDocuments?: IReadingRequestDocument[] | null;
  /** Procedure assegnate all'utente come commissario */
  assignedProcedures?: IProcedure[];
  /** Procedure assegnate all'utente come consultatore */
  consultantProcedures?: IProcedure[];
  /** Punteggi assegnati alle richieste dalla commissione */
  requestRanks?: ICommissionRank[] | null;
  /** Info utente su SIAP (calcolati alla login, solo per gli impiegati) */
  siap?: ISiapUserInfo | null;
}

export enum UserState {
  Authorized = 'Authorized',
  NeedEmailVerification = 'NeedEmailVerification',
  NeedProfileCompletition = 'NeedProfileCompletition',
  NeedPasswordSetup = 'NeedPasswordSetup'
}

export enum UserSource {
  Backoffice = 'Backoffice',
  EmailRegistration = 'EmailRegistration',
  TrustedSSO = 'TrustedSSO',
  /** Attraverso LDAP (o WS wrapper di LDAP) */
  Employee = 'Employee'
}
